import React from 'react'
import { Form } from 'antd';
import { Grid, TextField } from '@material-ui/core';

class siteForm extends React.Component {
  state = {
    confirmDirty: false,
    autoCompleteResult: [],
  };
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let variables = { 
          id: this.props.id, 
          name: values.name,
          email: values.email,
          password: values.password
        };
        if(values.password === this.props.password){
          variables = 
          { 
            id: this.props.id, 
            name: values.name,
            email: values.email
          };
        }
        this.props.query_f({ variables: variables })
        this.props.form.resetFields();
        if(this.props.onCancel){
          this.props.onCancel();
        }
      }
    });
  }
  handleConfirmBlur = (e) => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  }

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <form id="myForm" onSubmit={this.handleSubmit}>
        <Grid container spacing={0}>
        <Grid item xs={12}>
          {getFieldDecorator('name', { initialValue: (this.props.name || ''), rules: [{ required: true }], })(
            <TextField id="name" label="name"
                  color="primary" fullWidth style={{ marginTop : 13 }} InputLabelProps={{ shrink : true, }}
                  placeholder="name"/>
          )}
        </Grid>
        <Grid item xs={12}>
          {getFieldDecorator('email', { initialValue: (this.props.email || ''), rules: [{ required: true }], })(
            <TextField id="email" label="email"
                  color="primary" fullWidth style={{ marginTop : 13 }} InputLabelProps={{ shrink : true, }}
                  placeholder="email"/>
          )}
        </Grid>
        <Grid item xs={12}>
          {getFieldDecorator('password', { initialValue: (this.props.password || ''), rules: [{ required: true }], })(
            <TextField id="password" label="password" type="password"
                  color="primary" fullWidth style={{ marginTop : 13 }} InputLabelProps={{ shrink : true, }}
                  placeholder="password"/>
          )}
        </Grid>        
        </Grid>
        </form>
    );
  }
}

const sitesForm = Form.create()(siteForm);

export default sitesForm